import * as actionTypes from "../../Constants/actionTypes";
import lookupUtility from "../../Common/Utility/LookUpDataMapping";
import {initialState} from './getUsers';

const createUserReducer = (state = initialState, action) => {   
    switch (action.type) { 
      case actionTypes.GET_USER_DETAILS:      
        let _res = action.payload;
        if (_res.UserIndividualData) {
          let _detailsState = Object.assign({}, state);
          _detailsState.userData = _res.UserIndividualData;    
          _detailsState.insertstatus = "new"      
          state = _detailsState;
        }else{
          let _detailsState = Object.assign({}, state);
          _detailsState.insertstatus = "failed"      
          state = _detailsState;
        }
        return state;
      case actionTypes.GET_USER_LOOKUPS:
        let _lookupState = Object.assign({}, state);
        _lookupState.userProfileLook = lookupUtility.UserProfileLookup(
          action.payload
        );
        _lookupState.users = action.payload.userDetails;
        delete _lookupState.userProfileLook.userDetails;
        state = _lookupState;
        return state;
      case actionTypes.POST_USER_DETAILS:
        let _postState = Object.assign({}, state);
        //return lookupUtility.UserProfileLookup(action.payload,_newState.userProfileLook);
        _postState.insertstatus = action.payload.statusCode == 409?(_postState.error=action.payload.msg,_postState.insertstatus="conflict"):(action.payload == true ? "inserted" :  "failed" );
        if (action.payload != true)
          _postState.failedCount += 1;
        state = _postState;
        return state;
      case actionTypes.PUT_USER_DETAILS:
        let _putState = Object.assign({}, state);
          _putState.insertstatus = action.payload.statusCode == 409?(_putState.error=action.payload.msg,_putState.insertstatus="conflict"):(action.payload == true ? "inserted" :  "failed");
        if (action.payload != true)
          _putState.failedCount += 1;
        state = _putState;
        return state;
      case actionTypes.CHANGE_STATUS:
        let _changeState = Object.assign({}, state);        
        _changeState.insertstatus = "new";
        state = _changeState;
        return state;
        case actionTypes.MYCALENDER_BUCKET:
          let _mycalenderstate=Object.assign({}, state);
         if(action.payload === "add"){
          if(!_mycalenderstate.userProfileLook.pageDetails.filter((xx)=>xx.key==21).length)
          _mycalenderstate.userProfileLook.pageDetails.push({key:21,text: "My Calendar", value: "My Calendar"});
         } else{
          let _mycalenderindex=-1;
          _mycalenderstate.userProfileLook.pageDetails.map((x,i)=>{   
               if(x.key === 21)
                   _mycalenderindex=i;             
           });
           if(_mycalenderindex!==-1){
           _mycalenderstate.userProfileLook.pageDetails.splice(_mycalenderindex,1);
           state=_mycalenderstate;
           return state;
           }
         }
      default:
        return state;
    }
  };
  
  export default createUserReducer;